/**
 * Роли платформы. Названия и описания согласованы с Максимом 20.08.2026,
 * содержание ролей — по его же справочнику 21.08.2026.
 *
 * Список общий для ленты шагов на главной, раздела «Мои роли» в профиле и
 * страницы роли: это одни и те же роли, и расходиться их названия не должны.
 *
 * Описание двойное — в ленте карточка шире и вмещает, ради чего роль берут,
 * в профиле строка узкая и остаётся только суть.
 *
 * Выжимка на странице роли намеренно короткая: полные описания живут в
 * справочнике проекта, и туда ведёт ссылка. Перепечатывать их в кабинет —
 * значит завести второй источник правды, который разъедется с первым при
 * первой же правке.
 *
 * Гость выдаётся при регистрации, поэтому в ленте его нет: там показано,
 * что ещё можно открыть.
 *
 * Открыть роль можно двумя путями (Максим, 21.08.2026): пройти игровую
 * локацию и получить награду, которая её открывает, либо купить за монеты
 * FDP. Полей questUrl и priceFdp пока ни у одной роли нет — ни ссылок на
 * локации, ни цен нам не дали. Кнопка показывается только там, где поле
 * заполнено: кнопка, ведущая в никуда, хуже её отсутствия.
 */

const DOC = "https://breedy-1.gitbook.io/untitled/platforma-fairy-world";

export const PLATFORM_DOC = `${DOC}/platforma`;

export const ROLES = [
  {
    key: "guest",
    icon: "👤",
    title: "Гость",
    short: "Базовая роль, выдаётся при регистрации",
    long: "Базовая роль: видно общее устройство проекта.",
    granted: true,
  },
  {
    key: "hero",
    icon: "🦸",
    title: "Герой",
    short: "Квесты, AR-локации и награды",
    long: "Квесты, AR-локации, награды и прокачка навыков.",
    doc: `${DOC}/roli/geroi`,
    who: "Участник, который проходит AR-квесты, развивается через мини-проекты и зарабатывает первые баллы.",
    fits: "Новичкам в IT, путешественникам, геймерам, студентам, любителям AR",
    can: [
      "Проходить квесты и зарабатывать в игре",
      "Создавать контент без программирования",
      "Учиться в игровой форме",
      "Открывать себе следующие роли",
    ],
    gives: "Награды за активность, обмен баллов на товары и услуги, доход в командных проектах.",
    entry: "Условий нет — старт бесплатный.",
  },
  {
    key: "craftsman",
    icon: "🛠",
    title: "Ремесленник",
    short: "Задачи по специальности и портфолио",
    long: "Реальные задачи по специальности и портфолио.",
    doc: `${DOC}/roli/remeslenniki`,
    who: "Фрилансер, специалист или цифровой мастер, который берёт задачи и собирает портфолио.",
    fits: "Дизайнерам, маркетологам, разработчикам, фрилансерам, новичкам в творческих профессиях",
    can: [
      "Брать реальные проекты и внутренние заказы",
      "Растить портфолио через отзывы и рейтинг",
      "Учиться в Академии с наставником",
      "Работать в команде студии",
    ],
    gives: "Оплату за выполненные задания.",
    entry: "Условий нет: начинают с простых задач и растут.",
  },
  {
    key: "patronus",
    icon: "🎤",
    title: "Патронус",
    short: "Привлечение клиентов и участников",
    long: "Приводите клиентов, получайте процент со сделок.",
    doc: `${DOC}/roli/patronusy`,
    who: "Партнёр, который продаёт продукты платформы и получает комиссию со сделок.",
    fits: "Продавцам, блогерам, агентствам, менеджерам по продажам, тем, у кого есть своя клиентская база",
    can: [
      "Собирать свой набор продуктов на продажу",
      "Работать с ментором и обучением",
      "Входить в закрытое сообщество партнёров",
    ],
    gives: "Комиссию со сделок и бонусы за результат.",
    entry: "Заявка и вводное обучение.",
  },
  {
    key: "expert",
    icon: "🎓",
    title: "Эксперт",
    short: "Курсы и обучение в Академии Магии",
    long: "Курсы и обучение в Академии Магии.",
    doc: `${DOC}/roli/eksperty`,
    who: "Наставник, методолог или автор, который помогает участникам расти.",
    fits: "Коучам, тренерам, преподавателям, авторам курсов, онлайн-школам",
    can: [
      "Собирать обучающие курсы с игровой механикой",
      "Проводить воркшопы и эфиры на событиях платформы",
      "Вести консультации",
    ],
    gives: "Доход от курсов, консультаций и партнёрских программ.",
    entry: "Заявка.",
  },
  {
    key: "master",
    icon: "🤝",
    title: "Мастер",
    short: "Владелец бизнеса: подписка, лицензия, реклама",
    long: "Владелец бизнеса: подписка, лицензия, реклама.",
    doc: `${DOC}/roli/mastera`,
    who: "Предприниматель, который запускает AR-локации и работает по франшизе.",
    fits: "Владельцам бизнеса, руководителям сообществ, организаторам событий, собственникам площадок",
    can: [
      "Запускать AR-локации по франшизе",
      "Собирать команду из других участников",
      "Продвигать товары через квесты",
      "Пользоваться закрытыми инструментами и заказами",
    ],
    gives: "Долю дохода с билетов, миссий и заказов.",
    entry: "Пройти путь Героя, Патронуса или Хранителя, предложить площадку и согласовать формат.",
  },
  {
    key: "keeper",
    icon: "🗝",
    title: "Хранитель",
    short: "Франшиза и участие в управлении",
    long: "Франшиза и участие в управлении экосистемой.",
    doc: `${DOC}/roli/khraniteli`,
    who: "Партнёр или инвестор, который развивает экосистему, поддерживая проекты.",
    fits: "Инвесторам, владельцам объектов — парков, центров, отелей, IT-предпринимателям, бизнес-партнёрам",
    can: [
      "Запускать игровые локации и получать долю выручки",
      "Собирать портфель игровых активов",
      "Размещать свои продукты в квестах",
      "Участвовать в управлении экосистемой",
    ],
    gives: "Долю в доходах локаций и проектов, подтверждённую на платформе.",
    entry: "Заявка, выбор направления и вход в инвестиционный пул.",
  },
];

/** Роли, которые можно открыть: всё, кроме выданной при регистрации. */
export const OPENABLE_ROLES = ROLES.filter((role) => !role.granted);

/** Роль по ключу из адреса страницы. */
export const roleByKey = (key) => ROLES.find((role) => role.key === key) || null;
